import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);
const DoughnutChart = ({ width = 250, height = 250, values, labels, colors, showLegend = true, cutout = "70%" }) => {

  // Custom plugin
const noDataPlugin = {
  id: "noData",
  beforeDraw: (chart) => {
    const { data } = chart;
    if (
      !data.datasets.length ||
      data.datasets[0].data.every((v) => v === 0)
    ) {
      const { ctx, chartArea: { width, height } } = chart;
      chart.clear();

      ctx.save();
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.font = "16px sans-serif";
      ctx.fillStyle = "#666";
      ctx.fillText("No Data Available", width / 2, height / 2);
      ctx.restore();
    }
  },
};

  const baseColors = [
    "rgba(255, 99, 132, 0.5)",
    "rgba(54, 162, 235, 0.5)",
    "rgba(255, 206, 86, 0.5)",
    "rgba(75, 192, 192, 0.5)",
    "rgba(153, 102, 255, 0.5)",
    "rgba(255, 159, 64, 0.5)",
    "rgba(199, 199, 199, 0.5)",
    "rgba(83, 102, 255, 0.5)",
    "rgba(255, 205, 86, 0.5)",
    "rgba(201, 203, 207, 0.5)",
  ];

  const borderColors = baseColors.map((color) => color.replace("0.5", "1"));

  const data = {
    labels: labels,
    datasets: [
      {
        label: "Job Metrics",
        data: values,
        backgroundColor: colors || [
          "#4BC0C0",
          "#4FD1D9",
          "#1976D2",
          "#FFCE56",
          "#FF6384",
          "#9966FF",
          "#FF9F40",
        ],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    cutout, // This gives the doughnut appearance
    plugins: {
      legend: {
        display: showLegend,
        position: "bottom",
        labels: {
          boxWidth: 10, // Width of the color box
          boxHeight: 10, // Height of the color box (Chart.js v4+)
          font: {
            size: 12, // Optional: shrink font as well
          },
          padding: 15, // Optional: spacing between items
        },
      },
    },
  };

  return (
    <div style={{ width, height }}>
      <Doughnut data={data} width={width} height={height} options={options} plugins={[noDataPlugin]}/>
    </div>
  );
};

export default DoughnutChart;
